import { type IRelativeSchedulingRules } from '../../scheduling-rules';
import { type ITreatmentConfigurationRef } from './treatment-configuration';

export interface ITreatmentStepConfiguration {
  uid: string;
  name: string;
  treatments: ITreatmentConfigurationRef[];
  schedulingRules: IRelativeSchedulingRules;
}
